import React from "react";


const Anesthesiology = () => {

    return (
        <>
            <div className="dc-breadcrumbarea" style={{ background: '#ffffff' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <ol className="dc-breadcrumb">
                                <li className="dc-item-home">
                                    <a href="https://tech2day.co.in" title="Home">Home</a>
                                </li>
                                <li className="dc-item-current dc-item-cat">
                                    <span className="dc-bread-current bread-cat">Anesthesiology</span>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <main id="dc-main" className="dc-main dc-haslayout"><div className="container">
                <div className="row">
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 page-section pull-left">
                        <div className="blog-list-view-template">

                            <article className="dc-article ">
                                <div className="dc-articlecontent">
                                    <figure className="dc-classimg">
                                        <a href="//css.meddylist.com//could-gut-microbes-be-the-key-to-overcoming-muscle-loss-in-older-age/">
                                            <img src="//css.meddylist.com//wp-content/uploads/2019/09/Untitled-2_0022_Layer-7-1140x400.jpg" alt="Could gut microbes be the key to overcoming muscle loss?" /></a>					</figure>

                                    <div className="dc-title">
                                        <h3><a href="//css.meddylist.com//could-gut-microbes-be-the-key-to-overcoming-muscle-loss-in-older-age/">Could gut microbes be the key to overcoming muscle loss?</a></h3>
                                    </div>
                                    <div className="dc-description">
                                        <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed utem peiatis undesieu omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aiam eaqueiu ipsaquae abes illo inventore veritatisetm quasitea architecto beata...</p>
                                        <div className="dc-tagslist tagcloud d-flex dc-tags1 flex-wrap"><span>Categories:&nbsp;</span><a href="/anesthesiology" rel="tag">Anesthesiology</a></div>
                                        <ul className="dc-moreoptions dc-articlesmetadata">
                                            <li><i className="lnr lnr-clock"></i>September 13, 2019</li>
                                            <li className="dcget-likes" data-key="601"><a href="javascript:;"><i className="ti-heart"></i>15 Likes</a></li>
                                            <li><i className="ti-comment"></i>0 Comments</li>
                                        </ul>
                                    </div>
                                </div>
                            </article>

                            <article className="dc-article ">
                                <div className="dc-articlecontent">
                                    <figure className="dc-classimg">
                                        <a href="//css.meddylist.com//common-heartburn-drug-linked-with-fatal-conditions/">
                                            <img src="//css.meddylist.com//wp-content/uploads/2019/09/Untitled-2_0023_Layer-6-1140x400.jpg" alt="Common heartburn drug linked with fatal conditions" /></a>					</figure>

                                    <div className="dc-title">
                                        <h3><a href="//css.meddylist.com//common-heartburn-drug-linked-with-fatal-conditions/">Common heartburn drug linked with fatal conditions</a></h3>
                                    </div>
                                    <div className="dc-description">
                                        <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed utem peiatis undesieu omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aiam eaqueiu ipsaquae abes illo inventore veritatisetm quasitea architecto beatae...</p>
                                        <div className="dc-tagslist tagcloud d-flex dc-tags1 flex-wrap"><span>Categories:&nbsp;</span><a href="/anesthesiology" rel="tag">Anesthesiology</a></div>
                                        <ul className="dc-moreoptions dc-articlesmetadata">
                                            <li><i className="lnr lnr-clock"></i>September 13, 2019</li>
                                            <li className="dcget-likes" data-key="602"><a href="javascript:;"><i className="ti-heart"></i>0 Likes</a></li>
                                            <li><i className="ti-comment"></i>0 Comments</li>
                                        </ul>
                                    </div>
                                </div>
                            </article>

                            <article className="dc-article ">
                                <div className="dc-articlecontent">
                                    <figure className="dc-classimg">
                                        <a href="//css.meddylist.com//why-do-female-bonobos-have-more-sex-with-each-other-than-with-males/">
                                            <img src="//css.meddylist.com//wp-content/uploads/2019/09/Untitled-2_0025_Layer-4-1140x400.jpg" alt="Why do female bonobos have more sex than with males?" /></a>					</figure>

                                    <div className="dc-title">
                                        <h3><a href="//css.meddylist.com//why-do-female-bonobos-have-more-sex-with-each-other-than-with-males/">Why do female bonobos have more sex than with males?</a></h3>
                                    </div>
                                    <div className="dc-description">
                                        <p>Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Sed utem peiatis undesieu omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aiam eaqueiu ipsaquae abes illo inventore veritatisetm quasitea architecto beata...</p>
                                        <div className="dc-tagslist tagcloud d-flex dc-tags1 flex-wrap"><span>Categories:&nbsp;</span><a href="/anesthesiology" rel="tag">Anesthesiology</a></div>
                                        <ul className="dc-moreoptions dc-articlesmetadata">
                                            <li><i className="lnr lnr-clock"></i>September 13, 2019</li>
                                            <li className="dcget-likes" data-key="599"><a href="javascript:;"><i className="ti-heart"></i>14 Likes</a></li>
                                            <li><i className="ti-comment"></i>0 Comments</li>
                                        </ul>
                                    </div>
                                </div>
                            </article>
                        </div></div>
                    <aside id="dc-sidebar" className="col-xs-12 col-sm-12 col-md-12 col-lg-4 dc-sidebar-grid mt-lg-0 pull-right">
                        <div className="dc-sidebar">
                            <div id="search-3" className="dc-widget widget_search widget_categories"><form className="dc-formtheme dc-formsearch" method="get" role="search" action="//css.meddylist.com//">
                                <fieldset>
                                    <div className="form-group">
                                        <input type="search" name="s" value="" className="form-control" placeholder="Searching might help" />
                                        <button type="submit" className="dc-searchgbtn"><i className="fa fa-search"></i></button>
                                    </div>
                                </fieldset>
                            </form>


                            </div><div id="categories-4" className="dc-widget widget_categories widget_categories"><div className="doc-widgetheading"><h2>Categories</h2></div>
                                <ul>
                                    <li className="cat-item cat-item-18 current-cat"><a aria-current="page" href="/anesthesiology">Anesthesiology</a>
                                    </li>
                                    <li className="cat-item cat-item-19"><a href="/dermatology">Dermatology</a>
                                    </li>
                                    <li className="cat-item cat-item-20"><a href="/diagnosticradiology">Diagnostic radiology</a>
                                    </li>
                                    <li className="cat-item cat-item-21"><a href="/emergencymedicine">Emergency medicine</a>
                                    </li>
                                    <li className="cat-item cat-item-22"><a href="/familymedicine">Family medicine</a>
                                    </li>
                                </ul>

                            </div><div id="doctreat_tweets-3" className="dc-widget dc-widgettwitter widget_categories"><div className="doc-widgetheading"><h2>Tweets</h2></div>					<div className="txt-box">
                                <p>Sorry! No tweets found</p>
                            </div>
                            </div>


                        </div>
                    </aside>

                </div>
            </div>
            </main>

        </>

    );
};

export default Anesthesiology;
